// catalogService.js

const CATALOG_BASE_PATH = '/data';

async function fetchWithFallback(kind, fileName) {
  // Try API router first (avoids 404 noise from static in prod)
  try {
    const res = await fetch(`/api/catalog/${kind}`);
    if (res.ok) {
      const payload = await res.json();
      // API returns { ok: true, data: [...] }
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.data)) return payload.data;
    }
  } catch (_) {}
  // Fallback to static file
  try {
    const res = await fetch(`${CATALOG_BASE_PATH}/${fileName}`);
    if (res.ok) return await res.json();
  } catch (_) {}
  return [];
}

export const getLiquorCatalog = () => fetchWithFallback('liquor', 'liquorCatalog.json');

export const getLiqueurCatalog = () => fetchWithFallback('liqueur', 'liqueurCatalog.json');

export const getBeerCatalog = () => fetchWithFallback('beer', 'beerCatalog.json');

export const getWineCatalog = () => fetchWithFallback('wine', 'wineCatalog.json');

export const getChampagneCatalog = () => fetchWithFallback('champagne', 'champagneCatalog.json');

// Crown Produce unified catalog for juices, garnishes, etc.
export const getCrownCatalog = async () => {
  // Try Crown first
  const crown = await fetchWithFallback('crown', 'CrownCatalog.json');
  if (Array.isArray(crown) && crown.length) return crown;
  // Fallback to legacy juices
  return await fetchWithFallback('juices', 'juiceCatalog.json');
};

// Backward-compatible alias; existing code that calls getJuiceCatalog will still work
export const getJuiceCatalog = () => getCrownCatalog();

export const getSodaCatalog = () => fetchWithFallback('soda', 'sodaCatalog.json');

export const getSyrupCatalog = () => fetchWithFallback('syrups', 'syrupCatalog.json');

export const getSeltzerCatalog = () => fetchWithFallback('seltzer', 'seltzerCatalog.json');

// Example usage:
// import { getLiquorCatalog } from '../services/catalogService';
// useEffect(() => { getLiquorCatalog().then(setLiquorData); }, []);
